<template>
    <div class="flex flex-col items-center bg-white p-10">
        <img
                src="@/assets/icons/success-list.svg"
                class="my-11"
                alt="success"
        />
        <p class="text-body-4 text-default-9 font-normal">
            Thank you for submitting your request.

        </p>
        <p class="text-body-6 font-normal text-default-9 mt-10 text-center font-bold">
            Your profile is under review, and we will inform you of the outcome via email.
        </p>
        <p class="text-body-6 font-normal text-default-9 mt-2 text-center">
            Please check your inbox for further updates
        </p>
    </div>
</template>